
import { Component, ElementRef, Input, OnInit, ViewChild, DoCheck } from '@angular/core';
// tslint:disable-next-line: max-line-length
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSidenavModule, MatTooltipModule} from '@angular/material';
import { HttpClient } from "@angular/common/http";
import { SelectionModel, DataSource } from '@angular/cdk/collections';
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { environment } from "environments/environment";
import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe, formatCurrency, getCurrencySymbol} from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { EventEmitter } from 'events';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { stat } from 'fs';
import * as jQuery from 'jquery';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { GlobalService } from '../../../services/global.service';
import { Observable } from 'rxjs';
import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';

export interface PeriodicElement {
  id: string;
  cuit: string;
  empresa: string;
  fecha: string;
  importe: number;
  periodo: string;
  obs: string;
  contacto: string;
  comentario:string;
  responsable: string;
  estado: string;
}
var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-carga',
  templateUrl: './carga.component.html',
  styleUrls: ['./carga.component.css']
})

export class CargaComponent implements OnInit {

  @Input() navbarEmiter: NavbarComponent;
  @ViewChild('componenteNavbar') navbarComponent: NavbarComponent;

  // tslint:disable-next-line: no-inferrable-types
  modaless: string = 'modal-body';
  loading;
  loadingins;
  displayedColumns: string[] = ['select','id', 'cuit', 'empresa', 'fecha', 'importe', 'periodo', 'estado', 'comentario','boton'];
  dataSourceOpe = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  selection = new SelectionModel<PeriodicElement>(true, []);
  fecha_hoy;
  fechad;//input fecha desde
  fechah;//input fecha hasta
  filtroCuit; //input cuit para filtrar
  filtroEstado; //input estado para filtrar
  pid; pcuit; pfecha; pimporte; pperiodo; pobs; pestado; //para el body del post inserta nueva novedad
  id_mod; cuit_mod
  fechaparaInsert;
  role;
  userlog;
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public snackBar: MatSnackBar,
    private globalService: GlobalService
  ){ 
    this.loading=false;
    this.loadingins = false;
    this.fecha_hoy = new Date;
    this.fecha_hoy = this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
    this.fechaparaInsert = this.fecha_hoy;
    //this.fechah = this.fecha_hoy;
    this.filtroCuit = 'TODOS';
    this.filtroEstado = 'TODOS';
    this.pfecha = this.fecha_hoy;
    this.role=localStorage.getItem('role');
    this.userlog = localStorage.getItem('userId');
    console.log("ROLE: " + this.role);
    console.log("USERLOG: " + this.userlog)
  }

  obtenerNoti( evento ){
    console.log('noti obtenida', evento);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceOpe.filter = filterValue.trim().toLowerCase();
  }

  coco;

  async obtenerNotiGlobal() {

    // this.coco = await this.globalService.cargarNotis();
    // console.log('coco=', this.coco);

    await this.globalService.cargarNotis().then(lala => {
      console.log(lala);
    });


    // this.navbarComponent.getNotiGlobal();
  }

  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;

  }

  updateValue(value: string) {
    let val = parseInt(value, 10);
    if (Number.isNaN(val)) {
      val = 0;
    }
    //  console.log(formatCurrency(val, 'en-US', getCurrencySymbol('USD', 'wide')));
    let resp =  ( formatCurrency(val, 'en-US', getCurrencySymbol('USD', 'wide')).replace('$','') );
    return resp;
  }


  exportExcel2(data: any[]) {
    let arreglo = [];
    for (let _i = 0; _i < data.length; _i++) {
      if (data[_i]['estado'] === 'DEUDA') {
        let number = data[_i]['importe'];
        arreglo.push(
          {
            ID: data[_i]['id'],
            CUIT: data[_i]['cuit'],
            RAZON_SOCIAL: data[_i]['empresa'],
            PERIODO: data[_i]['periodo'],
            DEUDA: parseFloat(number)
          });
      }
    }

    console.log( arreglo );

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet( arreglo );
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, `DeudaSIDEU_${this.fechad}_al_${this.fechah}.xls`, { bookType: 'xls', type: 'buffer' });
  }

  itemElim;
  removeAt(n){
    //console.log("borrando: " + n);
    this.itemElim = n;
  }
  permiteEdicion = false;
  permitirEdicion(){
    this.permiteEdicion = !this.permiteEdicion;
    console.log(this.permiteEdicion);
  }

  loadingmodif = false;
  loadingUpdate = false;
  updateNovedad(){
    this.loadingUpdate = true;
    //http://localhost:1337/api/nuevaope/updateOp
    var body = {
      "id":  parseInt(this.modifid),
      "cui": this.modifcuit,
      "fec": this.modiffec,
      "imp": this.modifimporte,
      "per": this.modifperiodo,
      "obs": this.modifobs,
      "est": this.modifestado
    };
    console.log(body);
    this.loadingUpdate=true;
    this.http.post(`${environment.backendUrl}/api/nuevaope/updateOp`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
      if (status.status == 200){
        //console.warn("modificado OK!");   
        this.loadingUpdate=false;
        //document.getElementById("salirmodal").click();
        this.snackBar.open(`modificado!`, 'Cerrar', {duration: 5000});
        //this.cargarGrid();
        this.calculaHistorico(this.modifcuit);
        this.cargarGrid();
        console.log("modifica ok");
        //document.getElementById("salirmodal").click();
      }else{
        //console.warn("ERROR POST!");
        //console.log(JSON.stringify(status["error"]["code"]));
        this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
        console.log("fallo modificacion")
        this.loadingUpdate=false;
      }
    });   

  }

  loadingborrar;
  borrarNovedad(i){
    this.itemElim = i;
    //http://localhost:1337/api/nuevaope/borrar
    var body = {"i":i};
    this.loadingborrar=true;
    this.http.post(`${environment.backendUrl}/api/nuevaope/borrar`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
      if (status.status == 200){
        //console.warn("borrado OK!");   
        this.loadingborrar=false;
        document.getElementById("salirmodal").click();
        this.snackBar.open(`ELIMINADO!`, 'Cerrar', {duration: 5000});
        this.cargarGrid();
      }
      if (status.status == 500){
       // console.warn("ERROR POST!");
       // console.log(JSON.stringify(status["error"]["code"]));
        this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
        this.loadingborrar=false;
      }
    });
  }

  ngOnInit() {
    console.log(this.fecha_hoy);
    this.fechad = '2010-01-01';
    this.fechah = this.fecha_hoy;
    this.calculaEmpresas();
    //this.cargarGrid();
    
  }
  obse=false;
  habilitaobs(){
    if (this.obse == false){
      this.obse = true;
    }else{
      this.obse = false;
    }
  }
  
  status = false;
  habilitaestado(){
    if (this.status == false){
      this.status = true;
    }else{
      this.status = false;
    }
  }

  item = [{}];
  modifobs;
  modifestado;
  modifimporte;
  modifperiodo;
  modifid;
  modifcuit;
  modiffec;

  modalessHeader:string = 'modal-header';
  modalessBody;
  totregistros;

  pedro=false;

  ngDoCheck(){
    if (this.selection.selected[0] != null && this.selection.selected[0] != undefined){
      this.item = [];
      this.item.push(this.selection.selected[0]);
      //console.log(this.selection.selected[0]["id"]);
      console.log(this.item);
      this.modifobs = this.item[0]["obs"];
      this.modifestado = this.item[0]["estado"];
      this.modifimporte = this.item[0]["importe"];
      this.modifperiodo = this.item[0]["periodo"];
      this.modifid = this.item[0]["id"];
      this.modifcuit = this.item[0]["cuit"];
      this.modiffec = this.item[0]["fecha"];
      var body = {
        "id": this.modifid,
        "cui": this.modifcuit,
        "fec": this.modiffec,
        "imp": this.modifimporte,
        "per": this.modifperiodo,
        "obs": this.modifobs,
        "est": this.modifestado
      };
      //console.log(body);

    }else{
      //console.log("no se selecciono nada");
    }
    //console.log(this.filtroCuit + '-' + this.filtroEstado + '-' + this.fechad + '-'+this.fechah);

    //estilo css segun estado deuda::
    if (this.item[0]["estado"]=='DEUDA'){
      this.modalessBody='modal-body rojin';
      this.modalessHeader = 'modal-header rojin';
    }else{
      this.modalessBody='modal-body';
      this.modalessHeader = 'modal-header';
    }
    
  }

  habilitaPedro(){
    if (this.userlog == 'juanpedroverellen' || this.userlog == 'matiasmasciotta'){
      if (this.pedro==false){
        this.pedro = true;
      }else{
        this.pedro = false;
      }
      // console.log("HABILITANDO APEDRO");
    }
  }

  // tslint:disable-next-line: member-ordering
  comentarioPedro;

  // tslint:disable-next-line: member-ordering
  loadingPedro = false;

  actualizarComentario(i) {
    this.loadingPedro = true;
    const body = {
      'id': i,
      'comen' : this.comentarioPedro
     };

    // http://localhost:1337/api/nuevaope/updateComentario
    this.http.post(`${environment.backendUrl}/api/nuevaope/updateComentario`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
        if (status.status === 200){
          // console.warn("coment post OK!");
          this.loadingPedro = false;
          this.snackBar.open(`Comentario añadido a ${this.item[0]['empresa']}!`, 'Cerrar', {duration: 7000});

          this.globalService.cargarNotis();

          this.cargarGrid();
        }
        if (status.status === 500){
         // console.warn("ERROR POST!");
         // console.log(JSON.stringify(status["error"]["code"]));
          this.snackBar.open(`FALLO! ${JSON.stringify(status['error']['code'])}`, 'Cerrar', {duration: 7000});
          this.loadingPedro = false;
        } else {
          this.loadingPedro = false;
        }
      }
    );

 }


  clean(){
    this.selection.clear();
  }

  cargarGrid(){
    this.loading=true;
      this.dataSourceOpe.data =  null;
      //http://localhost:1337/api/nuevaope/consulta?cuit=TODOS&fecd=2015-01-01&fech=2021-01-01&esta=TODOS
      this.http.get(`${environment.backendUrl}/api/nuevaope/consulta?cuit=${this.filtroCuit}&fecd=${this.fechad}&fech=${this.fechah}&esta=${this.filtroEstado}`)
      .subscribe((datos: any[]) => {
        if(datos){
          this.dataSourceOpe.data = datos[0];
          //console.log(this.dataSourceOpe.data);
          this.totregistros = this.dataSourceOpe.data.length;
        }else{
          //console.warn("NO HAY");
        };
        this.loading=false;
      });
  }
  
  loadingNuevaNovedad = false;
  insertarNovedad2(){
    this.loadingNuevaNovedad = true;
    if (this.modifimporte == '' || this.modifimporte == null){
      this.modifimporte = '0';
    }
    var body = {
      "cui": `${this.modifcuit}`,
      "fec": `${this.fechaparaInsert}`,
      "imp": `${this.modifimporte}`,
      "per": `${this.modifperiodo}`,
      "obs": `${this.modifobs}`,
      "est": `${this.modifestado}`
    };
    //console.log("$$insertando desde edit----------->");
   // console.warn(body);
    //http://localhost:1337/api/nuevaope/insert
    this.http.post(`${environment.backendUrl}/api/nuevaope/insert`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
        if (status.status == 200){
         // console.warn("post OK!");   
          this.loadingNuevaNovedad=false;
          this.snackBar.open(`Nueva nodedad insertada para ${this.item[0]["empresa"]}!`, 'Cerrar', {duration: 5000});
          this.cargarGrid();
          document.getElementById("salirmodal").click();
        }
        if (status.status == 500){
          //console.warn("ERROR POST!");
          //console.log(JSON.stringify(status["error"]["code"]));
          this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
          this.loadingNuevaNovedad=false;
        }else{
          this.loadingNuevaNovedad = false;
        }
      }
    );
  
  }

  insertaNuevo(){
    this.loadingins = true;
    if (this.pimporte == '' || this.pimporte == null){
      this.pimporte = '0';
    }
    var body = {
      "cui": `${this.pcuit}`,
      "fec": `${this.pfecha}`,
      "imp": `${this.pimporte}`,
      "per": `${this.pperiodo}`,
      "obs": `${this.pobs}`,
      "est": `${this.pestado}`
    };

    //http://localhost:1337/api/nuevaope/insert
    this.http.post(`${environment.backendUrl}/api/nuevaope/insert`, body)
    .subscribe(
      res => console.log('---RES OK', res),
      status => {
        if (status.status == 200){
          //console.warn("post OK!");   
          this.snackBar.open(`Insertado OK!`, 'Cerrar', {duration: 5000});
          this.loadingins=false;
          this.cargarGrid();
        }
        if (status.status == 500){
          //console.warn("ERROR POST!");
          //console.log(JSON.stringify(status["error"]["code"]));
          this.snackBar.open(`FALLO! ${JSON.stringify(status["error"]["code"])}`, 'Cerrar', {duration: 5000});
          this.loadingins=false;
        }
      }
    );
  
  }

  dataSourceEmpresas;
  loadingemp;
  calculaEmpresas(){
    this.loadingemp=true;
    //http://localhost:1337/api/nuevaope/calculaemp
    this.http.get(`${environment.backendUrl}/api/nuevaope/calculaemp`)
    .subscribe((datos: any[]) => {
      if(datos){
        this.dataSourceEmpresas = datos[0];
        //console.log(this.dataSourceEmpresas);
      }else{
        //console.warn("NO HAY");
      };
      this.loadingemp=false;
    });
  }
  
  dataSourceHistorico;
  loadingHistorico=false;
  calculaHistorico(cuit){
    this.loadingHistorico=true;
    //http://localhost:1337/api/nuevaope/calculahistorico?cui=30601290800
    this.http.get(`${environment.backendUrl}/api/nuevaope/calculahistorico?cui=${cuit}`)
    .subscribe((datos: any[]) => {
      if(datos){
        this.dataSourceHistorico = datos;
        this.modiffec = this.datePipe.transform(this.dataSourceHistorico[0]['fecha'], "yyyy-MM-dd");
        console.log(this.modiffec);
        //console.log(this.dataSourceHistorico);
        this.loadingHistorico=false;
      }else{
        //console.warn("NO HAY");
        this.loadingHistorico=false;
      };
      
    });
  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceOpe.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSourceOpe.data.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
    this.clean();
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


}
